// extracted by mini-css-extract-plugin
module.exports = {"section":"policyTable_section__P8VWt","threeColumns":"policyTable_threeColumns__xwQ_k","hide":"policyTable_hide__gdOkK"};